<template>
  <div class="lazy-users">
    <mainmenu selected="report_last_stock_update"></mainmenu>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <h1>{{$t('report_last_stock_update.page_title')}}</h1>
        </div>
        <div class="col-md-6 text-right">
          <a class="btn btn-success" :href="BaseUrl +'/api/index.php/Report_last_stock_update/export_excel'">{{$t('report_last_stock_update.export_to_excel')}}</a>
        </div>
      </div>
      

        <el-card>
            <table class="table" v-if="Report.length>0" >
                <tr>
                    <th>{{$t('report_last_stock_update.user')}}</th>
                    <th>{{$t('report_last_stock_update.factory')}}</th>
                    <th>{{$t('report_last_stock_update.last_update')}}</th>
                </tr>
                <tr v-for="u in Report" :key="u.Id">
                    <td><strong>{{u.Name}}</strong></td>
                    <td>{{u.FactoryShortCode}}</td>
                    <td>
                        <span v-if="u.Days!='-1'">
                            {{u.Days}} {{$t('report_last_stock_update.days')}}
                        </span>
                        <span v-else>
                            {{$t('report_last_stock_update.never')}}
                        </span>
                    </td>
                </tr>
            </table>

            <div v-else>
                {{$t('report_last_stock_update.all_users_are_ok')}}
            </div>
        </el-card>
    </div>
  </div>
</template>

<script>
import MainMenu from "./../../widgets/MainMenu";
import settings from "./../../backend/LocalSettings";

export default {
  name: "report_last_stock_update",
  components: {
    "mainmenu": MainMenu
  },
  data () {
    return { 
      BaseUrl: settings.base_url,
      tableLoadingVisible: false,
      Report: [],
      NotRespondingUsers: []
    }
  },
  methods: {
    
    refresh_info: function() {
      this.loadingVisible = true;
      this.$http
          .post('report_last_stock_update/refresh_info',  {  } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Report = response.body.Report;
            } else {
              this.$router.push("/");
            }
          }); 
    }
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>
  .button-link{
    text-decoration: none;
  }
</style>